var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCloseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 14.13-7.452 7.452Q4.128 22 3.483 22q-.647 0-1.065-.418Q2 21.162 2 20.517q0-.646.418-1.064L9.871 12 2.418 4.548Q2 4.128 2 3.483q0-.647.418-1.065Q2.838 2 3.483 2q.646 0 1.065.418L12 9.871l7.453-7.453Q19.87 2 20.517 2t1.065.418q.418.42.418 1.065 0 .646-.418 1.065L14.129 12l7.453 7.453q.418.417.418 1.064t-.418 1.065q-.42.418-1.065.418-.646 0-1.064-.418z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseFill);
export default __webpack_public_path__ + "static/media/x_close_fill.70cbbb3d3ca59bb058c156dc7073fb7e.svg";
export { ForwardRef as ReactComponent };